(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;
  document.documentElement.classList.add('vr-pages-ready');
  const localLink = (href, label, className = '') => {
    const link = document.createElement('a');
    link.href = href;
    link.textContent = label;
    if (className) link.className = className;
    return link;
  };
  const enhanceCards = () => {
    main.querySelectorAll('.collection-grid-section .product-card-content, .vr-search .product-card-content').forEach(content => {
      if (content.querySelector('.vr-view-product')) return;
      const title = content.querySelector('a.collection-title, .collection-title a') || content.querySelector('a');
      if (!title || !title.href.includes('/products/')) return;
      const link = localLink(title.href, 'Ver prenda', 'vr-view-product');
      link.setAttribute('aria-label', `Ver ${title.textContent.trim()}`);
      content.append(link);
    });
  };
  const enhanceCart = () => {
    const empty = main.querySelector('.cart-empty');
    if (!empty || empty.querySelector('.vr-empty-shopping')) return;
    const shopLink = main.querySelector('.section-header-with-button a');
    empty.append(localLink(shopLink?.href || '/collections/all', 'Explorar colección', 'vr-empty-shopping'));
  };
  const enhanceFilters = () => {
    const searchProducts = main.querySelector('.vr-search .search-result-products');
    searchProducts?.classList.add('filter-style-sidebar');
    main.querySelectorAll('.facets-shortby-title').forEach(label => {
      [...label.childNodes].forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Sort by') node.textContent = ' Ordenar';
      });
    });
    main.querySelectorAll('#SidebarfacetForm').forEach(form => {
      if (form.querySelector('.vr-filter-clear')) return;
      const url = new URL(location.href);
      [...url.searchParams.keys()].filter(key => key.startsWith('filter.')).forEach(key => url.searchParams.delete(key));
      url.searchParams.delete('page');
      const clear = localLink(url.pathname + url.search, 'Limpiar filtros', 'vr-filter-clear');
      form.append(clear);
      form.closest('[role=dialog]')?.setAttribute('aria-label', 'Filtrar prendas');
    });
  };
  const enhancePolicies = () => {
    const policy = main.querySelector('.shopify-policy__container');
    if (!policy || policy.closest('.vr-policy-layout')) return;
    const paths = new Map();
    document.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.href);
      const title = link.textContent.trim();
      if (url.origin === location.origin && url.pathname.includes('/policies/') && title && title.length < 90) paths.set(url.pathname, title);
    });
    const heading = policy.querySelector('.shopify-policy__title h1');
    if (!paths.has(location.pathname)) paths.set(location.pathname, heading?.textContent.trim() || 'Política vigente');
    const crumb = document.createElement('nav');
    crumb.className = 'vr-policy-breadcrumb';
    crumb.setAttribute('aria-label', 'Ruta de navegación');
    crumb.append(localLink('/', 'Inicio'), document.createTextNode('/'), localLink('/pages/contacto', 'Ayuda'), document.createTextNode('/'), document.createTextNode(heading?.textContent.trim() || 'Política vigente'));
    policy.before(crumb);
    const wrapper = document.createElement('section');
    wrapper.className = 'vr-policy-layout';
    const navigation = document.createElement('nav');
    navigation.className = 'vr-policy-nav';
    navigation.setAttribute('aria-label', 'Ayuda y políticas');
    const navHeading = document.createElement('h2');
    navHeading.textContent = 'Ayuda';
    navigation.append(navHeading);
    const label = document.createElement('label');
    label.className = 'vr-policy-select-label';
    label.textContent = 'Consultar';
    const select = document.createElement('select');
    select.setAttribute('aria-label', 'Consultar otra política');
    paths.forEach((title, path) => {
      const link = localLink(path, title);
      if (path === location.pathname) link.setAttribute('aria-current', 'page');
      navigation.append(link);
      const option = document.createElement('option');
      option.value = path;
      option.textContent = title;
      option.selected = path === location.pathname;
      select.append(option);
    });
    select.addEventListener('change', () => location.assign(select.value));
    label.append(select);
    navigation.append(label);
    policy.before(wrapper);
    wrapper.append(navigation, policy);
    const body = policy.querySelector('.shopify-policy__body');
    const subtitle = document.createElement('p');
    subtitle.className = 'vr-policy-subtitle';
    subtitle.textContent = 'Consulta las condiciones vigentes.';
    policy.querySelector('.shopify-policy__title')?.after(subtitle);
    const headings = body ? [...body.querySelectorAll('h2,h3,p > strong:first-child')].filter(item => item.textContent.trim() && (item.matches('h2,h3') || item.parentElement.firstElementChild === item)) : [];
    headings.forEach(item => item.classList.add('vr-policy-section-heading'));
    if (headings.length > 1) {
      const details = document.createElement('details');
      details.className = 'vr-policy-toc';
      const summary = document.createElement('summary');
      summary.textContent = 'En esta página';
      const list = document.createElement('nav');
      list.setAttribute('aria-label', 'En esta página');
      headings.forEach((item, index) => {
        if (!item.id) item.id = `vr-policy-heading-${index + 1}`;
        list.append(localLink(`#${item.id}`, item.textContent.trim()));
      });
      details.append(summary, list);
      body.before(details);
    }
    const help = document.createElement('aside');
    help.className = 'vr-policy-help';
    const helpHeading = document.createElement('h2');
    helpHeading.textContent = '¿No encuentras lo que buscas?';
    const helpText = document.createElement('p');
    helpText.textContent = 'Estamos aquí para ayudarte.';
    const actions = document.createElement('div');
    actions.className = 'vr-policy-help__actions';
    const contact = localLink('/pages/contacto', 'Contacto');
    const whatsapp = localLink('https://wa.me/573127766135', 'WhatsApp');
    whatsapp.target = '_blank';
    whatsapp.rel = 'noopener';
    const icon = (paths) => {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '1.5'); svg.setAttribute('aria-hidden', 'true');
      paths.forEach(d => { const path = document.createElementNS('http://www.w3.org/2000/svg', 'path'); path.setAttribute('d', d); svg.append(path); });
      return svg;
    };
    contact.prepend(icon(['M3 5h18v14H3zM3 5l9 7 9-7']));
    whatsapp.prepend(icon(['M20 11.5a8 8 0 0 1-11.8 7L4 20l1.5-4.2A8 8 0 1 1 20 11.5Z','M9 8c0 4 3 7 7 7']));
    actions.append(contact, whatsapp);
    help.append(helpHeading, helpText, actions);
    policy.append(help);
  };
  let queued = false;
  const enhance = () => {
    queued = false;
    enhanceCards();
    enhanceCart();
    enhanceFilters();
    enhancePolicies();
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(enhance);
  };
  enhance();
  new MutationObserver(queue).observe(main, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', queue);
  document.addEventListener('submit', event => {
    if (event.target.id !== 'SidebarfacetForm' || !matchMedia('(max-width:767px)').matches) return;
    const close = event.target.closest('facets-filter-drawer')?.querySelector('[data-close-drawer].drawer-close');
    if (close) setTimeout(() => close.click(), 0);
  });
})();
